module.exports = __webpack_public_path__ + "assets/img/yypt_d_p3.8438180d.png";